import React, { useState } from "react";
import { Link } from "react-router-dom";

import {
  BackArrowIcon2,
  LayoutGuide,
  Subheading_Info,
  heading_Sub,
  scrollxLogo,
} from "../../../assets/icons";
import "../InfoProject.css";

export default function LayoutNewUser() {
  const [active, setActive] = useState(""); // State to track active element id
  const [layoutStartOpt,setLayoutStartOpt] = useState(true);
  const [headingOPt, setHeadingOPt] = useState(false);
  const [alignOPt, setAlignOPt] = useState(false);
  const [widthOPt, setWidthOPt] = useState(false);
  const [blockInsetOPt, setBlockInsetOPt] = useState(false);
  const [arrangOPt, setArrangOPt] = useState(false);
  const [marginOPt, setMarginOPt] = useState(false);
  const [balanceOPt, setBalanceOPt] = useState(false);
  const [orderOPt, setOrderOPt] = useState(false);

  console.log("active = ", active);

  const nextToContinue = (id) => {
    setActive(id); // Set the active state to the id of the clicked element
    if (id === "aligntype") {
      setHeadingOPt(false);
      setAlignOPt(true);
      setWidthOPt(false);
      setBlockInsetOPt(false);
      setArrangOPt(false);
      setMarginOPt(false);
      setOrderOPt(false);
      setBalanceOPt(false);
      setLayoutStartOpt(false);

    } else if (id === "headtype") {
      setHeadingOPt(true);
      setAlignOPt(false);
      setWidthOPt(false);
      setBlockInsetOPt(false);
      setArrangOPt(false);
      setMarginOPt(false);
      setOrderOPt(false);
      setBalanceOPt(false);
      setLayoutStartOpt(false);
      
    } else if (id === "arrangtype") {
      setArrangOPt(true);
      setBlockInsetOPt(false);
      setHeadingOPt(false);
      setAlignOPt(false);
      setWidthOPt(false);
      setMarginOPt(false);
      setOrderOPt(false);
      setBalanceOPt(false);
      setLayoutStartOpt(false);

    } else if (id === "widthtype") {
      setWidthOPt(true);
      setHeadingOPt(false);
      setAlignOPt(false);
      setBlockInsetOPt(false);
      setArrangOPt(false);
      setMarginOPt(false);
      setOrderOPt(false);
      setBalanceOPt(false);
      setLayoutStartOpt(false);

    } else if (id === "blockInserttype") {
      setBlockInsetOPt(true);
      setHeadingOPt(false);
      setAlignOPt(false);
      setWidthOPt(false);
      setArrangOPt(false);
      setMarginOPt(false);
      setOrderOPt(false);
      setBalanceOPt(false);
      setLayoutStartOpt(false);

    } else if (id === "margintype") {
      setMarginOPt(true);
      setArrangOPt(false);
      setBlockInsetOPt(false);
      setHeadingOPt(false);
      setAlignOPt(false);
      setWidthOPt(false);
      setOrderOPt(false);
      setBalanceOPt(false);
      setLayoutStartOpt(false);

    } else if (id === "balancetype") {
      setMarginOPt(false);
      setArrangOPt(false);
      setBlockInsetOPt(false);
      setHeadingOPt(false);
      setAlignOPt(false);
      setWidthOPt(false);
      setBalanceOPt(true);
      setOrderOPt(false);
      setLayoutStartOpt(false);

    } else if (id === "ordertype") {
      setMarginOPt(false);
      setArrangOPt(false);
      setBlockInsetOPt(false);
      setHeadingOPt(false);
      setAlignOPt(false);
      setWidthOPt(false);
      setBalanceOPt(false);
      setOrderOPt(true);
      setLayoutStartOpt(false);

    }
  };

  return (
    <div className="w-full h-full">
      {/* Header */}
      <div className="h-[64px] px-[10%] w-full flex items-center justify-between LayoutNewUser-nav">
      <Link to="/dashboard/projectInstructions">
      <nav className=" flex items-center">
          <img
            className="ml-[-22px]   w-[47px]"
            src={BackArrowIcon2}
            alt=""
            style={{ cursor: "pointer" }}
          />
              <img className="w-[42px] h-[50px]  mr-2" src={scrollxLogo} />
              <h1 className="Syne text-xl font-extrabold tracking-wide ml-[-0.4rem] text-[#dee3eb]">
              {" "}
              SCROLLX.io <span className="Syne text-lg  tracking-wide text-[#dee3eb]">help</span>
            </h1>
          </nav>
      </Link>
        <div>
          <button className="text-[17px] text-white rounded border-[1px] px-3  py-1">
            Go to website
          </button>
        </div>
      </div>
      {/* Main content */}
      <div className="flex w-full h-full px-[10%]">
        {/* Main content area */}
        <div className="w-3/5  py-5 ">
          {/* Ordering option */}
          <div
            className={orderOPt === true ? "InfoOverlay" : "InfoOverlayNone"}
          ></div>
          {orderOPt && (
            <div className="w-[90%] pr-[10%] h-[90%] overflow-y-auto scroll_bar">
              <div className="w-full h-full  text-black FontFamily-Avenir-reg p-2">
                <div>
                  <h1 className="py-3 text-black FontFamily-Avenir text-2xl">
                    Layout Option: Ordering
                  </h1>
                </div>
                <div className="py-3">
                  <h1 className="text-black FontFamily-Avenir  text-4xl">
                    Ordering features
                  </h1>
                  <h3 className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    In the Name-only block type, specifically when arranged in
                    columns, the Ordering feature provides flexibility in how
                    names are arranged. Here's what you need to know:
                  </h3>
                </div>
                <div>
                  <h1 className="py-2 text-black FontFamily-Avenir text-[22px]">
                    Column Flow:
                  </h1>
                  <li className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    Dictates the arrangement of names within multi-column
                    blocks.
                  </li>
                  <li className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    Two options available:
                  </li>
                  <h1 className="py-2 text-black FontFamily-Avenir text-[22px]">
                    Column Flow: Horizontal:
                  </h1>
                  <li className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    {" "}
                    Names flow horizontally across columns.
                  </li>

                  <h1 className="py-2 text-black FontFamily-Avenir text-[22px]">
                    Column Flow: Vertical:
                  </h1>
                  <li className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    {" "}
                    Names stack vertically within each column.
                  </li>
                  <img className="py-3" src="https://scrollx-gif-uploads.s3.amazonaws.com/Layout/Name-only_Option_For_Gif/Webp/Name-only_Layout_Column_Flow_Options_240305.webp" alt="" />
                  <h1 className="py-2 text-black FontFamily-Avenir text-[22px]">
                    Alphabetical Flow:
                  </h1>
                  <li className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    {" "}
                    Controls the alphabetical ordering of names.
                  </li>
                  <li className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    Three options offered:
                  </li>
                  <h1 className="py-2 text-black FontFamily-Avenir text-[22px]">
                    Alphabetical Flow Default (as in Google Sheets):Follows the
                    default alphabetical order.
                  </h1>
                  <li className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    {" "}
                    Alphabetical Flow A - Z: Arranges names from A to Z.
                  </li>
                  <li className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    Alphabetical Flow Z - A: Arranges names from Z to A.
                  </li>

                  <h3 className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    By selecting the appropriate Column Flow and Alphabetical
                    Flow options, you can customize the organization of names
                    within multi-column blocks to suit your preferences and
                    improve readability.
                  </h3>
                  <img src="https://scrollx-gif-uploads.s3.amazonaws.com/Layout/Name-only_Option_For_Gif/Webp/name-only_layout_alphabetical_options_240305.webp" alt="" />
                </div>
              </div>
            </div>
          )}
          {/* Balance option */}
          <div
            className={balanceOPt === true ? "InfoOverlay" : "InfoOverlayNone"}
          ></div>
          {balanceOPt && (
            <div className="w-[90%] pr-[10%] h-[90%] overflow-y-auto scroll_bar">
              <div className="w-full h-full  text-black FontFamily-Avenir-reg p-2">
                <div>
                  <h1 className="py-3 text-black FontFamily-Avenir text-2xl">
                    Layout Option: Balance
                  </h1>
                </div>
                <div className="py-3">
                  <h1 className="text-black FontFamily-Avenir   text-4xl">
                    Balance features
                  </h1>
                  <h3 className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    The Balance Columns feature is exclusively available within
                    the 'name-only' block type. Here's how it enhances your
                    layout:
                  </h3>
                  
                </div>
                <div>
                  <h1 className="py-2 text-black FontFamily-Avenir text-[22px]">
                    Symmetrical Layouts
                  </h1>
                  <li className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    Automatically adjusts multi-column blocks to ensure
                    symmetrical presentation.
                  </li>
                  <li className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    Prevents single elements ("orphans") from being left at the
                    bottom of columns.
                  </li>
                  <h1 className="py-2 text-black FontFamily-Avenir text-[22px]">
                    Enhanced Visual Appeal:
                  </h1>
                  <li className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    Shifts orphan elements to adjacent columns, maintaining
                    balance and aesthetics.
                  </li>
                  <li className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    Improves overall visual harmony and readability of your
                    content.
                  </li>
                  <h3 className="py-2 text-black FontFamily-Avenir-reg text-[20px]">
                    By enabling Balance Columns, you effortlessly optimize your
                    layout, creating a more balanced and visually pleasing
                    design.
                  </h3>
                  <img className="py-3" src="https://scrollx-gif-uploads.s3.amazonaws.com/Layout/Songs_Layout_Option_for_Gif/Webp/Songs-Layout-Balance-Options_240305.webp" alt="" />
                </div>
              </div>
            </div>
          )}
          {/* Margin option */}
          <div
            className={marginOPt === true ? "InfoOverlay" : "InfoOverlayNone"}
          ></div>
          {marginOPt && (
            <div className="w-[90%] pr-[10%] h-[90%] overflow-y-auto scroll_bar">
              <div className="w-full h-full  text-black FontFamily-Avenir-reg p-2">
                <div>
                  <h1 className="py-3 text-black FontFamily-Avenir text-2xl">
                    Layout Option: Margin
                  </h1>
                </div>
                <div className="py-3">
                  <h1 className="text-black FontFamily-Avenir   text-4xl">
                    Margin features
                  </h1>
                  <h3 className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    Within the margin option, two distinct features enable
                    precise adjustments:
                  </h3>
                </div>
                <div className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                  <h1 className="py-2 text-black FontFamily-Avenir text-[22px]">
                    Vertical Margin:
                  </h1>
                  <li className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    Guarantees uniform top and bottom margins, set at a fixed
                    percentage.
                  </li>
                  <img className="py-3" src="https://scrollx-gif-uploads.s3.amazonaws.com/Layout/Layout_Margin_Option_For_Gif/Webp/Layout-Margin-Vertical-Options_240305.webp" alt="" />
                  <h1 className="py-2 text-black FontFamily-Avenir text-[22px]">
                    Bottom Margin Adjustment:
                  </h1>
                  <li className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    Facilitates fine-tuning of the bottom margin.
                  </li>
                  <li className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    Incrementally adjustable in units of 1, 2, 3, and up to 25,
                    providing granular control over spacing.
                  </li>
                  <img className="py-3" src="https://scrollx-gif-uploads.s3.amazonaws.com/Layout/Layout_Margin_Option_For_Gif/Webp/Layout-Margin-Bottom-Options_240305.webp" alt="" />
                </div>
                
              </div>
            </div>
          )}
          {/* Arrangement option */}
          <div
            className={arrangOPt === true ? "InfoOverlay" : "InfoOverlayNone"}
          ></div>
          {arrangOPt && (
            <div className="w-[90%] pr-[10%] h-[90%] overflow-y-auto scroll_bar">
              <div className="w-full   text-black FontFamily-Avenir-reg p-2">
                <div>
                  <h1 className="py-3 text-black FontFamily-Avenir text-2xl">
                    Layout Option: Arrangement
                  </h1>
                </div>
                <div className="py-3">
                  <h1 className="text-black FontFamily-Avenir   text-4xl">
                    Arrangement features
                  </h1>
                  <h3 className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    In your layout option, there are three types of blocks, each
                    with distinct arrangements of features:
                  </h3>
                </div>
                <div className="">
                  <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                    Role+Name Block:
                  </h3>
                  <h3 className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    - Contains a single feature, with roles followed by
                    corresponding names.
                    <br />- Ensure roles precede names, maintaining the same
                    order for both roles and names.
                  </h3>
                  <img className="py-3" src="https://scrollx-gif-uploads.s3.amazonaws.com/Layout/Role-Name_Option_for_Gif/Webp/role-name_layout_arrangement_options_240605.webp" alt="" />

                  <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                    Nameonly Block:
                  </h3>
                  <h3 className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    - Two variations:
                    <br />
                    - Names arranged in columns, adjustable up to five columns.
                  <img className="py-3" src="https://scrollx-gif-uploads.s3.amazonaws.com/Layout/Name-only_Option_For_Gif/Webp/name-only_layout_arrangement_column_options_240305.webp" alt="" />

                    <br />- Names in columns can be converted into paragraphs.
                  </h3>

                  <img className="py-3" src="https://scrollx-gif-uploads.s3.amazonaws.com/Layout/Name-only_Option_For_Gif/Webp/Name-only-Layout-Arrangement_Paragraph_Option_240305.webp" alt="" />
                  <h3 className="py-2 text-black FontFamily-Avenir text-2xl">
                    Song Block
                  </h3>
                  <h3 className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    - Features identical to those in the Nameonly columns.
                    <br />- Maintain consistency with the Nameonly block's
                    arrangement.
                  </h3>

                  <img className="py-3"  src="https://scrollx-gif-uploads.s3.amazonaws.com/Layout/Songs_Layout_Option_for_Gif/Webp/Songs-Layout-Arrangement-Options_240305.webp" alt="" />
                </div>
              </div>
            </div>
          )}
          {/* Block Inset option */}
          <div
            className={
              blockInsetOPt === true ? "InfoOverlay" : "InfoOverlayNone"
            }
          ></div>
          {blockInsetOPt && (
            <div className="w-[90%] pr-[10%] h-[90%] overflow-y-auto scroll_bar">
              <div className="w-full h-full  text-black FontFamily-Avenir-reg p-2">
                <div>
                  <h1 className="py-3 text-black FontFamily-Avenir text-2xl">
                    Layout Option: Block Inset
                  </h1>
                </div>
                <div className="py-3">
                  <h1 className="text-black FontFamily-Avenir   text-4xl">
                    Block Inset features
                  </h1>

                  <h3 className="py-2 text-black FontFamily-Avenir-reg text-[20px]">
                    If you aim to incorporate videos or still images alongside
                    your credits, the "Block Inset" feature comes in handy.
                    Here's what you need to know:
                  </h3>

                  <img className="py-3" src="https://scrollx-gif-uploads.s3.amazonaws.com/Layout/Block-Inset_Option_For_Gif/Webp/Layout-Block-Inset-Options-4-Gif.webp" alt="" />
                </div>
                <div className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                  <li className="FontFamily-Avenir-reg text-[17px]">
                    By default, this block is halved to fit within the title
                    safe width, aligning flush with the left or right side of
                    the title safe area.
                  </li>
                  <li className="FontFamily-Avenir-reg text-[17px]">To arrange two blocks side by side:</li>
                  <li className="FontFamily-Avenir-reg text-[17px]">
                    Select the second block to position it beside the first.
                  </li>
                  <li className="FontFamily-Avenir-reg text-[17px]">Set its Block Inset to Right and enable Side by Side.</li>
                  <li className="FontFamily-Avenir-reg text-[17px]">Choose the preceding block.</li>
                  <li className="FontFamily-Avenir-reg text-[17px]">Set its Block Inset to Left and enable Side by Side.</li>
                </div>
                
                  <h3 className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    Following these steps, you can seamlessly align blocks side
                    by side. However, as each block occupies half the title-safe
                    width, watch for wrapping names or words. Adjust layouts or
                    font sizes as needed for optimal design.
                  </h3>
               
              </div>
            </div>
          )}
          {/* Width option */}
          <div
            className={widthOPt === true ? "InfoOverlay" : "InfoOverlayNone"}
          ></div>
          {widthOPt && (
            <div className="w-[90%] pr-[10%] h-[90%] overflow-y-auto scroll_bar">
              <div className="w-full h-full  text-black FontFamily-Avenir-reg p-2">
                <div>
                  <h1 className="py-3 text-black FontFamily-Avenir text-2xl">
                    Layout Option: Width
                  </h1>
                </div>
                <div className="py-3 ">
                  <h1 className="text-black FontFamily-Avenir   text-4xl">
                    Width features
                  </h1>
                  <h3 className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    Width refers to the measurement of the distance between the
                    opposite sides of an object. It is commonly used to describe
                    the size of an object and can be measured in pixels or
                    percentages.
                  </h3>
                  <img className="py-3" src="https://scrollx-gif-uploads.s3.amazonaws.com/Layout/Name-only_Option_For_Gif/Webp/Name-only_Layout_Column_Width_Options_240305.webp" alt="" />
                </div>
                
                  <h3 className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    "This feature is capable of working with left, right,
                    justify, and ragged alignments, but it does not work with
                    gutter/center alignment."
                  </h3>
                
              </div>
            </div>
          )}

          {/* Alignment option  */}
          <div
            className={alignOPt === true ? "InfoOverlay" : "InfoOverlayNone"}
          ></div>
          {alignOPt && (
            <div className="w-[90%] pr-[10%] h-[90%] overflow-y-auto scroll_bar">
              <div className="w-full h-full  text-black FontFamily-Avenir-reg p-2">
                <div>
                  <h1 className="py-3 text-black FontFamily-Avenir text-2xl">
                    Layout Option: Alignment
                  </h1>
                </div>
                <div className="py-3">
                  <h1 className="text-black FontFamily-Avenir   text-4xl">
                    Alignment features
                  </h1>
                  <h3 className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    In your layout option, alignment plays a crucial role in
                    presenting content cohesively. There are two key features
                    that determine alignment choices:
                  </h3>
                </div>
                <div>
                  <h1 className="py-2 text-black FontFamily-Avenir text-2xl">
                    1. Double Column and Single Column
                  </h1>
                  <img className="py-3" src="https://scrollx-gif-uploads.s3.amazonaws.com/Layout/Role-Name_Option_for_Gif/Webp/role-name_layout_alignment_single-column_options_240605.webp" alt="" />
                  <h3 className=" text-black FontFamily-Avenir-reg text-[17px]">
                    - This feature is exclusively utilized in the Role + Name
                    block.
                    <br />- It allows for the selection between a double-column
                    layout and a single-column layout, offering flexibility in
                    structuring content.
                  </h3>
                  <img className="py-3" src="https://scrollx-gif-uploads.s3.amazonaws.com/Layout/Role-Name_Option_for_Gif/Webp/role-name_layout_alignment_double-single-column_options_240605.webp" alt="" />
                </div>
                <div className=" py-3">
                  <h1 className="py-2 text-black FontFamily-Avenir text-2xl">
                    2. Different Types of Text Alignment and Justification
                    Options{" "}
                  </h1>
                  <h1 className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    Text alignment refers to how text is positioned within a
                    text box or a page, providing various options to enhance
                    readability and aesthetics.
                  </h1>
                  <h3 className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                    1. Left-aligned: Text aligns to the left margin, appearing
                    flush on the left side and ragged on the right.
                    <br />
                    2. Right-aligned: Text aligns to the right margin, appearing
                    flush on the right side and ragged on the left.
                    <br />
                    3. Center-aligned: Text is horizontally centered within the
                    page or text box, with ragged edges on both sides.
                    <br />
                    4. Justified: Text aligns to both the left and right
                    margins, creating an evenly spaced appearance between words
                    for a clean look.
                    <br />
                    5. Ragged: The default alignment where text is ragged on
                    both sides, not aligned to any margin.
                  </h3>
                  <img className="py-3" src="https://scrollx-gif-uploads.s3.amazonaws.com/Layout/Role-Name_Option_for_Gif/Webp/role-name_layout_alignment_double-column_options_240605.webp" alt="" />
                </div>
              </div>
            </div>
          )}
          {/* Heading and subheading */}
          <div
            className={headingOPt === true ? "InfoOverlay " : "InfoOverlayNone"}
          ></div>
          {headingOPt && (
            <div className="w-[90%] pr-[10%] h-[90%] overflow-y-auto scroll_bar">
              <div>
                <h1 className="py-3 text-black FontFamily-Avenir text-2xl">
                  Layout Option: Heading and Subheading
                </h1>
              </div>
              <div className="py-3">
                <h1 className="text-black FontFamily-Avenir text-4xl">
                  Heading and Subheading features
                </h1>
                <h3 className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                  In your layout option, you'll find the "Heading" and
                  "Subheading" options, acting as text boxes for inputting text
                  displayed at the top of your block types. Here's a breakdown:
                </h3>
              </div>
              <div className="py-3 w-full">
                <img className="w-10/12" src={heading_Sub} alt="" />
              </div>
              <div>
                <h3 className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                  Heading: The primary title or summary, larger and prominent,
                  guiding the focus of the section.
                </h3>
              </div>
              <div>
                <img className="w-10/12" src={Subheading_Info} alt="" />
                <h3 className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                  Subheading: Offers additional context, smaller than headings,
                  aiding in organization and providing detailed overviews within
                  sections.
                </h3>
              </div>
              <div className="py-5 ">
                <h1 className=" text-black FontFamily-Avenir   text-4xl">
                  Heading and Subheading in Render
                </h1>
                <img className="py-3" src="https://scrollx-gif-uploads.s3.amazonaws.com/Layout/Heading_Sub-heading_for_Gif/Webp/layout_heading_sub-heading_4-tutorial_240905.webp" alt="" />
              </div>
            </div>
          )}
          {/* Layout option */}
          <div
            className={layoutStartOpt === true ? "InfoOverlay " : "InfoOverlayNone"}
          ></div>
          {layoutStartOpt && (
            <div className="w-[90%] pr-[10%] h-[90%] overflow-y-auto scroll_bar">
              <div>
                <h1 className="py-3 text-black FontFamily-Avenir text-4xl">
                Start Here: Layout Page Guide
                </h1>
                <h3 className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                Welcome to the Layout page! This is where you can personalize your Special Thanks block. Here’s how to get started and use the layout controls:
                </h3>
              </div>
              <div className="py-3">
                <h1  className="text-black FontFamily-Avenir pb-3  text-2xl">Customize Your Layout</h1>
                  <h1 className="text-black FontFamily-Avenir   text-[22px]">
                  Columns
                  </h1>
                  <h3 className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                  Choose how many columns you want for your Special Thanks block. You can go for a single column for simplicity or multiple columns for variety.
                  </h3>
                  {/* <h1 className="text-black FontFamily-Avenir   text-[22px]">
                  Alignment
                  </h1>
                  <h3 className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                  Select how the names should be aligned within the block. Options include left, center, or right alignment.
                  </h3> */}
                </div>  
              <div>
              <img className="py-3" src={LayoutGuide} alt="" />

                <h1 className="text-black FontFamily-Avenir   text-2xl">Using the Layout Controls</h1>
                
                <li className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                Click: Move your mouse over a row to make buttons appear.
                  </li>
                  {/* <li className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                  Choose Your Settings: Click the buttons to set the number of columns, alignment, and other options.
                  </li> */}
                  <h3 className="py-2 text-black FontFamily-Avenir-reg text-[17px]">
                  These easy controls let you adjust the layout quickly without emails or lengthy discussions. Make changes and see them instantly.
                                 
                </h3>
                <h3 className="py-2 text-black FontFamily-Avenir-reg text-[17px]"> Enjoy setting up your Thanks block with just a few clicks!</h3>
              </div>
              
            </div>
          )}
        </div>
        {/* Sidebar */}
        <div className="w-2/5 py-5  capitalize">
          <div className=" ">
            <h1 className="text-2xl Syne700 py-3">Layout Option categories</h1>
            <h2 className="text-[20px] FontFamily-Avenir-reg py-2 ">The sections below explain how each control functions:</h2>
            <div className=" py-[4%] normal-case w-full text-[17px] place-items-start place-content-center grid gap-3 grid-cols-1 overflow-y-auto">
              <div
                key={1}
                className={`w-[90%] py-3 pl-2 flex items-center justify-between cursor-pointer rounded border-[1px]  border-white-700 ${
                  active === "headtype" ? "active123" : "InfoLayoutOption"
                }`}
                id={"headtype"}
                onClick={() => nextToContinue("headtype")}
              >
                <div>Heading and Sub-heading</div>
              </div>
              <div
                key={2}
                className={`w-[90%] py-3 pl-2 flex items-center justify-between cursor-pointer rounded border-[1px]  border-white-700 ${
                  active === "aligntype" ? "active123" : "InfoLayoutOption"
                }`}
                id={"aligntype"}
                onClick={() => nextToContinue("aligntype")}
              >
                <div className="w-full">Alignment</div>
              </div>
              {/* Add more options */}
              <div
                key={3}
                className={` w-[90%] py-3 pl-2 flex items-center justify-between cursor-pointer rounded border-[1px]  border-white-700 InfoLayoutOption ${
                  active === "arrangtype" ? "active123" : "InfoLayoutOption"
                }`}
                id={"3"}
                onClick={() => nextToContinue("arrangtype")}
              >
                Arrangement
              </div>

              <div
                key={4}
                className={` w-[90%] py-3 pl-2 flex items-center justify-between cursor-pointer rounded border-[1px]  border-white-700  ${
                  active === "widthtype" ? "active123" : "InfoLayoutOption"
                }`}
                id={"widthtype"}
                onClick={() => nextToContinue("widthtype")}
              >
                Width
              </div>

              <div
                key={5}
                className={` w-[90%] py-3 pl-2 flex items-center justify-between cursor-pointer rounded border-[1px]  border-white-700 InfoLayoutOption ${
                  active === "blockInserttype"
                    ? "active123"
                    : "InfoLayoutOption"
                }`}
                id={"5"}
                onClick={() => nextToContinue("blockInserttype")}
              >
                Block Inset
              </div>

              <div
                key={6}
                className={` w-[90%] py-3 pl-2 flex items-center justify-between cursor-pointer rounded border-[1px]  border-white-700 InfoLayoutOption ${
                  active === "margintype" ? "active123" : "InfoLayoutOption"
                }`}
                id={"6"}
                onClick={() => nextToContinue("margintype")}
              >
                Margin
              </div>

              <div
                key={7}
                className={` w-[90%] py-3 pl-2 flex items-center justify-between cursor-pointer rounded border-[1px]  border-white-700 InfoLayoutOption ${
                  active === "balancetype" ? "active123" : "InfoLayoutOption"
                }`}
                id={"7"}
                onClick={() => nextToContinue("balancetype")}
              >
                Balance
              </div>

              <div
                key={8}
                className={` w-[90%] py-3 pl-2 flex items-center justify-between cursor-pointer rounded border-[1px]  border-white-700 InfoLayoutOption ${
                  active === "ordertype" ? "active123" : "InfoLayoutOption"
                }`}
                id={"7"}
                onClick={() => nextToContinue("ordertype")}
              >
                Ordering
              </div>
              {/* <div className='w-[90%] py-3 pl-2 flex items-center justify-between cursor-pointer rounded border-[1px]  border-white-700 InfoLayoutOption'>
                Heading and Sub-heading
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
